import React, { useEffect, useState } from 'react';
import { Between, LabelNumric, Label, ButtonLink, LabelSmall, Row, StepBody, StepFooter } from 'meitav-uikit';
import utils from 'utils';
import { UmbracoStep, UmbracoChildren } from 'components/Umbraco/UmbracoContext';
import { postData, uploadFilesToBack, setDataLayer } from '../../../../../utils/Functions';
import "./step34.scss";
import FileItem from "./FileItem";
import Footer from 'components/Footer';
import { Parser } from 'html-to-react';

const { UmbracoUtills, rest } = utils;

export default function Step34({
  resource,
  model,
  setModel,
  setStep,
  step,
  dataList,
  nextText,
  setDataList,
  disable
}) {

  const resourceStep = UmbracoStep(resource, `SecondSub4Step`);
  const p = new Parser();

  const fileItems = UmbracoChildren(resource, `SecondSub4Step`);
  const [fileList, setFileList] = useState(dataList.digitalFile.fileList34);

  const [bank, setBank] = useState({});
  const [branch, setBranch] = useState({});

  useEffect(() => {
    let tmp = {};
    fileItems.forEach(item => {

      let fileTypeID = UmbracoUtills.getValueByKey(item, 'fileTypeID');
      tmp[fileTypeID] = {};
      tmp[fileTypeID].name = UmbracoUtills.getValueByKey(item, 'title');
      tmp[fileTypeID].file = ""
      if (fileList != null && fileList[fileTypeID] && fileList[fileTypeID].file) {
        tmp[fileTypeID].file = fileList[fileTypeID].file;
      }

    });
    setFileList(tmp);
  }, []);
  useEffect(() => {
    getPaymentsDetails();
  }, []);

  const getPaymentsDetails = async () => {

    if (dataList.banks.length == 0) {
      const res = await rest.get(`/api/general/GetBankList`);
      const res2 = await rest.get(`/api/general/GetBranchesList`);

      let tmpList = { ...dataList };
      tmpList.banks = res?.data;
      tmpList.branches = res2?.data;
      setDataList(tmpList);
      localStorage.setItem('dataList', JSON.stringify(tmpList));

    }
  };

  useEffect(() => {
    if (model.paymentDetails.depositBankNum) {
      setBank(dataList.banks.find(
        x => x.BankID === model.paymentDetails.depositBankNum,
      ));
    }
    if (model.paymentDetails.depositBankSnif) {
      setBranch(dataList.branches.find(
        x => x.BankId === model.paymentDetails.depositBankNum && x.BranchNum === model.paymentDetails.depositBankSnif,
      ));
    }
  }, [dataList]);

  const urlBankLink = () => {

    setDataLayer("PM - bank deposit", window.location.pathname, "הרשאת חיוב חשבון", "הקלקה על מעבר לאתר הבנק בשלב פרטי הפקדה להעברה בנקאית");
    window.open(model.paymentDetails?.bankSiteURL ? model.paymentDetails?.bankSiteURL : bank?.BankSiteURL, '_blank');
  }
  const handleNext = async () => {
    if (disable) {
      setStep(41);
      return;
    }
    let tmpData = dataList;
    tmpData.digitalFile.fileList34 = fileList;

    setDataList(tmpData);
    localStorage.setItem('dataList', JSON.stringify(tmpData));

    let tmpModel = model;
    tmpModel.currentStepID = 34;

    tmpModel.stepID = 41;
    postData(tmpModel, setStep);
    uploadFiles();

  };
  const uploadFiles = async () => {
    let list = {};

    Object.keys(fileList).map(function (key) {
      if (fileList[key].file != "") {
        list[key] = fileList[key].file;
      }
    });

    if (list != null)
      uploadFilesToBack(list);
  };
  const handlePrev = async () => {
    setDataLayer("PM - Levels", "/JoinPersonalDetails", "חזור לשלב הקודם", "חזרה - " + step);

    let tmpModel = model;
    setModel(tmpModel);
    if (tmpModel.paymentDetails.depositTypeId === 2)
      setStep(32);
    else setStep(31);
  };

  return (
    <div className="step34">
      <StepBody>
        <Row>
          <Row>
            <Label text={UmbracoUtills.getValueByKey(resourceStep, 'sumDeposit')} />
            <LabelNumric id="depositSum" prefix='₪' size="big" addClass="special-bold" text={model.paymentDetails?.depositSum || model.mainUser?.depositSum} />
          </Row>
          <div className="hr"></div>
          <Row>
            <Label>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "bankDetailsTo")}</Label>
            <div className="hr"></div>
            <Row className="box">
              <Label>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "bankDetailsFrom")}</Label>

              <Between className='line'>
                <Row type='shrink'>
                  <LabelSmall>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "bank")}</LabelSmall>
                  <Label addClass="special">{`${bank?.BankID} - ${bank?.BankName}`}</Label>
                </Row>
                <Row type='shrink'>
                  <LabelSmall>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "branch")}</LabelSmall>
                  <Label addClass="special">{`${branch?.BranchNum} - ${branch?.BranchName}`}</Label>
                </Row>
              </Between>
              <Between className='line'>
                <Row type='shrink'>
                  <LabelSmall>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "accountNum")}</LabelSmall>
                  <Label addClass="special">{model.paymentDetails.depositBankAccountNum}</Label>
                </Row>
                <Row type='shrink'>
                  <LabelSmall>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "accountFullName")}</LabelSmall>
                  <Label addClass="special">{model.paymentDetails.depositBankAccountFullName}</Label>
                </Row>
              </Between>
              <Between className='line'>
                <Row type='shrink'>
                  <ButtonLink text={UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "urlBank")} onClick={urlBankLink}></ButtonLink>
                  <LabelSmall>{UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "urlText")}</LabelSmall>
                </Row>
              </Between>
            </Row>
          </Row>
          <Row>
            <FileItem
              disable={disable}
              key={1}
              item={fileItems[0]}
              fileList={fileList}
              setFileList={setFileList}
            />
          </Row>
        </Row>
      </StepBody>
      <StepFooter nextText={nextText}
        handleNext={handleNext} handlePrev={handlePrev} />
      <Footer text={p.parse(UmbracoUtills.getValueByKey(
        resourceStep,
        "mainText"
      ))}></Footer>
    </div>
  );
}
